import React, { useState } from 'react';
import {
    DetailsMainContainerBlock,
    MainContainerItems,
    SurgeryTitle,
    SurgerySubTitle,
} from './AccountDetailsSection.styled';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { useSelector } from 'react-redux';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
const AccountDetailsSection = ({ isConsignmentReturn = false }) => {
    const { t } = useTranslation();

    const accountDetail = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails
    );

    const isFromOrderHistory = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.isFromOrderHistory
    );

    const surgeryNumber = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.surgeryNumber
    );

    const { specialStockPartner } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const [isAccountDetails, setIsAccountDetails] = useState(true);

    const districtName = accountDetail?.orderSummaryDetail?.districtName;
    const districtCode = accountDetail?.orderSummaryDetail?.districtCode;
    const derivedTerritoryDetails = accountDetail?.orderSummaryDetail?.derivedTerritoryDetails?.[0];
    const territoryName = derivedTerritoryDetails?.territoryName;
    const territory = derivedTerritoryDetails?.territory;

    return (
        <>
            <CollapsableCard
                id="orders-accountDetailsSection-accountDetailsSection-details"
                title={t('ConsignmentAdd.submit.accountDetails')}
                onClick={() => setIsAccountDetails(!isAccountDetails)}
                isExpanded={isAccountDetails}
                padding={'0.8rem'}
                cursor={'pointer'}
                // CollapsableCardIconWidthHeight={'12px'}
            >
                {isAccountDetails ? (
                    <DetailsMainContainerBlock setMarginTop={!isConsignmentReturn} mbMarginTop={'0px'}>
                        {isConsignmentReturn && districtName && (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.district'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {districtName}{' '}
                                    {districtCode ? districtCode : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        )}
                        {isConsignmentReturn && territoryName && (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.territory'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {territoryName}{' '}
                                    {territory ? territory : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        )}
                        <MainContainerItems setMarginBottom={false}>
                            <SurgeryTitle showAstrisk={false}>
                                {t(
                                    'orders.orderListViewFilterDropDown.account'
                                )}
                            </SurgeryTitle>
                            <SurgerySubTitle className="orders-detail-account-dt-mask">
                                {accountDetail.accountName}{' '}
                                {accountNumberZeroTrimmer(
                                    accountDetail.accountNumber
                                )}
                            </SurgerySubTitle>
                        </MainContainerItems>
                        {specialStockPartner && (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderDetails.orderSummary.surgeryDetails.splStockPartner'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-detail-stock-partner-dt-mask">
                                    {specialStockPartner}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        )}
                        {!isFromOrderHistory && accountDetail.billToNumber && (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('equity.billToDetails.title')}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-detail-bill-to-dt-mask">
                                    {accountDetail.billToName}{' '}
                                    {accountNumberZeroTrimmer(
                                        accountDetail.billToNumber
                                    )}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        )}
                        {surgeryNumber ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('common.surgeryNumberLabel')}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {surgeryNumber}{' '}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                    </DetailsMainContainerBlock>
                ) : null}
            </CollapsableCard>
        </>
    );
};
export default AccountDetailsSection;
